import { computed } from "vue";
import { useMissionStore } from "@/store/modules/mission";

export const useMissionConfig = () => {
  const missionsStore = useMissionStore();

  const selectedElementaryMissions = computed(
    () => missionsStore.currentMission?.elementaryMissions || [],
  );

  return {
    selectedElementaryMissions,
  };
};
